﻿window.cSendSms = function (bddRef, textMessage, hasStop) {
    var Me = this;

    this.nbCarBySmsString = 150
    if (hasStop) this.nbCarBySmsString -= 12
    this.nbCarBySmsUnicode = 60
    this.isUniCode = function () {
        var content = textMessage
        if (content == null) content = ""
        for (var i = 0, n = content.length; i < n; i++) {
            if (content.charCodeAt(i) > 255) { return true; }
        }
        return false;
    }

    this.mGetMaxCar = function () {
        return this.mGetNbCarBySms() * 6
    }
    this.mGetNbCarBySms = function () {
        return ((this.isUniCode()) ? this.nbCarBySmsUnicode : this.nbCarBySmsString)
    }

    this.mGetNbCaractereMessage = function (withLienCourt) {
        if (typeof withLienCourt == 'undefined') withLienCourt = true
        var content = textMessage
        if (content == null) content = ""
        var nbOccurenceLink = 0
        if (withLienCourt) {
            var content = textMessage
            if (content == null) content = ""
            var result = ""
            content.split("|$a|").forEach(function (text, idx) {
                if (idx % 2 != 0) {
                    //on est sur un lien
                    result += ""
                    nbOccurenceLink += 1
                } else { result += text }
            })
            content = result
        } else { content = content.remplacerTout("|$a|","") }
        return content.length + 32 * nbOccurenceLink
    }
    this.mGetNbCredit1MessageFrance = function (withLienCourt) {
        if (typeof withLienCourt == 'undefined') withLienCourt = true
        return Math.ceil(this.mGetNbCaractereMessage(withLienCourt) / this.mGetNbCarBySms())
    }
    this.mGetNbCredit1Message = function (codePays, withLienCourt) {
        if (typeof withLienCourt == 'undefined') withLienCourt = true
        var nbCreditFrance = this.mGetNbCredit1MessageFrance(withLienCourt)
        var priceFrance = parametre.lstIndicatifTel.filter(function (ind) { return ind.code == "fr" })[0].price
        if (parametre.lstIndicatifTel.filter(function (ind) { return ind.code == codePays }).length == 0) debugger;
        var pricePays = parametre.lstIndicatifTel.filter(function (ind) { return ind.code == codePays })[0].price
        var nbCredit = Math.ceil((1 / priceFrance) * pricePays * nbCreditFrance)
        return nbCredit
    }

    this.mGetDivTarifSmsParPays = function (contentElement) {
        var $Div = $("<div style='width:100%;white-space:normal;height:100%;'/>")
        var $DivEntete = $("<div/>").appendTo($Div)
        $("<div style='font-size:200%;line-height:1;'>Nbre de crédits<br/>par SMS par pays</div>").appendTo($DivEntete)
        $("<div style='font-size:100%;padding-top:5px;'>Pour la France métropolitaine<br/>1 SMS = 1 crédit</div>").appendTo($DivEntete)
        $("<hr style='opacity:0.3'/>").appendTo($DivEntete)
        if (typeof contentElement != 'undefined') $Div.appendTo(contentElement)
        var dxScroll = $("<div style='white-space:normal;height:calc(100% - " + ($DivEntete.innerHeight() + 0) + "px);'/>").appendTo($Div).dxScrollView({}).dxScrollView("instance")
        var $Table = $("<table style='width:100%'/>").appendTo(dxScroll.content())
        var indicFrance = parametre.lstIndicatifTel.filter(function (o) { return o.code == "fr" })[0]
        var $Tr = $("<tr style='opacity:0.3'/>").appendTo($Table)
        var $Td = $("<td style='width:1px;'></td > ").appendTo($Tr)
        var $Td = $("<td style='text-align:left;width:100%;'>Pays</td > ").appendTo($Tr)
        var $Td = $("<td style='width:1px;'>crédit/SMS</td>").appendTo($Tr)
        parametre.lstIndicatifTel.sort(function (o1, o2) { return (o1.name).localeCompare(o2.name) }).forEach(function (indic) {
            var $Tr = $("<tr style='opacity:0.7'/>").appendTo($Table)
            if (indic.code == "fr") {
                $Tr.css({ "font-weight": "bold", "font-size": "150%", "opacity": "1" })
                $Tr.addClass("blinkscalealways")
            }
            var $Td = $("<td style='width:1px;'><img src='https://flagcdn.com/w20/" + indic.code.toLowerCase() + ".png' style='padding-right:5px;padding-top:5px;'/></td > ").appendTo($Tr)
            var $Td = $("<td style='text-align:left;width:100%;'>" + indic.name + "</td > ").appendTo($Tr)
            var nbCredit = parseInt((1 / indicFrance.price) * indic.price * 100) / 100
            var $Td = $("<td style='width:1px;'>" + nbCredit.formatDisplay(2) + "</td>").appendTo($Tr)
        })
        return $Div
    }

    this.mGetTxtWithLinkInHtml = function (withLienCourt) {
        if (typeof withLienCourt == 'undefined') withLienCourt = true
        var content = textMessage
        if (content == null) content = ""
        var result = ""
        var idx = 0
        content.split("|$a|").forEach(function (text, idx) {
            if (idx % 2 != 0) {
                //on est sur un lien
                if (withLienCourt) text = "" + parametre.url_appli + "/XXXXXX/clc"
                result += "<a href='javascript:void(0)' target='_blank'>" + text + "</a>"
            } else { result += text }
            idx += 1
        })
        return result
    }

    this.mGetTextSmsWithSeparateurLink = function () {
        var content = textMessage
        if (content == null) content = ""
        var lstLink = []
        var urlRegex = /(https?|ftp|ssh|mailto):\/\/[a-z0-9\/:%_+.,#?!@&=-]+/gi
        var lstMatch = content.match(urlRegex)
        if (lstMatch != null) lstMatch.forEach(function (match) {
            var link = {
                link: match,
                text: "hyperlien_popsoft_" + lstLink.length
            }
            lstLink.push(link)
            content = content.replace(match, "|$a|" + link.text + "|$a|")
        })
        var urlRegex = /(www.)[a-z0-9\/:%_+.,#?!@&=-]+/gi
        var lstMatch = content.match(urlRegex)
        if (lstMatch != null) lstMatch.forEach(function (match) {
            var link = {
                link: match,
                text: "hyperlien_popsoft_" + lstLink.length
            }
            lstLink.push(link)
            content = content.replace(match, "|$a|" + link.text + "|$a|")
        })
        lstLink.forEach(function (link) {
            content = content.replace(link.text, link.link)
        })
        return content
    }

    this.mGetTextWithoutSeparateurLink = function () {
        var content = textMessage
        if (content == null) content = ""
        return content.remplacerTout("|$a|", "")
    }

    this.mSendSmsMessageClientImmediat = function (target,telSms, funcSended) {
        var nbCredit = 0
        var tel = new cTelephone(null, telSms)
        nbCredit = Me.mGetNbCredit1Message(tel.codePays,false)
        if (bddRef.objCptCli.objetMetier.mGetNbSmsDispo() < nbCredit) {
            //pas de crédit SMS
            $("body").find(".dx-ctrljauge").each(function () {
                var jauge = $(this).getInstance()
                jauge.mHide();
            })

            bddRef.objCptCli.objetMetier.mSignaleLimiteAbonnement(target, "Vous ne disposez pas<br/>de crédit SMS.<br/>Accédez à votre compte<br/>pour acheter des packs SMS.", "Acheter des crédits SMS", 3, function () {
                $("<div/>").appendTo("body").dxCtrlAchatPopup({
                    bddCtrl: bddRef,
                    typeProduit: "credit_sms",
                    nb: 5,
                    onPaiement: function () {
                        jaugeDemarrage.mShow()
                        bddRef.mReloadTable("credit_sms", function () { jaugeDemarrage.mHide() })
                    }
                })
            })
            return
        } else {
            bddRef.objCptCli.objetMetier.mUseSms(nbCredit)
            bddRef.mAjaxCall({
                command: "sendsmsmessageclient",
                tel_sms: telSms,
                messagesms: textMessage
            }, function (data) {
                funcSended()
                //mNotify("Un sms a été envoyé avec le lien internet pour un reglement CB", "success", 8000)
                //mExecAttenteReglementCbWithJauge()
            })
        }
    }

}